/**
 * Utility functions for placeholder replacement
 */

/**
 * Escapes special characters in a string for safe JSON insertion
 */
export const escapeForJSON = (str: string): string =>
  str
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\r')
    .replace(/\\t/g, '\t')
    .replace(/\\/g, '\\\\') // Escape backslashes first
    .replace(/"/g, '\\"') // Escape double quotes
    .replace(/\n/g, ' ') // Escape newlines
    .replace(/\r/g, ' ') // Escape carriage returns
    .replace(/\t/g, ' '); // Escape tabs

/**
 * Replaces @CUAPROMPT@ placeholders in form data with escaped user prompt
 */
export const replacePlaceholders = (
  formData: Record<string, unknown>,
  userPrompt: string | null | undefined
): Record<string, unknown> => {
  const processedData = JSON.parse(JSON.stringify(formData)) as Record<
    string,
    unknown
  >;

  const replaceInObject = (obj: unknown): unknown => {
    if (typeof obj === 'string') {
      if (userPrompt != null) {
        // Escape special characters in user prompt to prevent JSON breakage
        const escapedPrompt = escapeForJSON(userPrompt);

        return obj.replace(/@CUAPROMPT@/g, escapedPrompt);
      }

      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item: unknown) => replaceInObject(item));
    }

    if (obj && typeof obj === 'object') {
      const result: Record<string, unknown> = {};

      Object.entries(obj as Record<string, unknown>).forEach(([key, value]) => {
        result[key] = replaceInObject(value);
      });

      return result;
    }

    return obj;
  };

  return replaceInObject(processedData) as Record<string, unknown>;
};
